import { RESULT_OK, get } from "@/api/apiutil";
import {
  RequestPagination,
  SearchCriteriaItem,
  DetectedManagedNodeResponse,
} from "@/libs/vulnUtil";
import {
  API_PATH_VVT,
  SYSTEM_ERROR,
  getPaginationParams,
  getCriteriaParams,
} from "./util";

export const getList = (payload: {
  pagination: RequestPagination;
  criteria: SearchCriteriaItem;
}) => {
  let path = API_PATH_VVT + "/managed-nodes";

  const params = getPaginationParams(payload.pagination).concat(
    getCriteriaParams(payload.criteria, "severity"),
  );
  if (params.length > 0) {
    path = path + "?" + params.join("&");
  }

  return new Promise(
    (
      resolve: (res: DetectedManagedNodeResponse) => void,
      reject: (err: string) => void,
    ) => {
      get(path)
        .then((res) => {
          if (res.ok === true) {
            res.json().then((json) => {
              if (json.result === RESULT_OK) {
                resolve(json.data);
              } else {
                reject(json.reason_code);
              }
            });
          } else {
            reject("status:" + res.status);
          }
        })
        .catch(() => {
          reject(SYSTEM_ERROR);
        });
    },
  );
};
